import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { CommentCreateData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCreateComment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CommentCreateData): Promise<string> => {
      const result = await apiClient.comment.createComment.mutation({ body: data });

      if (result.status !== 200) throw result.body;
      return result.body.message as string;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['comments'] });
      toast.success(`New comment was created!`);
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || `Error creating the comment!`);
    },
  });
};
